'use strict'

class CommonConfig {
  constructor() {
    this.urlApi = process.env.NODE_ENV === 'development' ? 'http://test.smartix.team/' : './'
  }

  getUrlApi() {
    return this.urlApi
  }
}

export default new CommonConfig()
